const scheduleMap: Map<string, () => void> = new Map();
export const scheduleJob = (
  tag: string,
  seconds: number,
  callback: () => void,
) => {
  const clearTimer = scheduleMap.get(tag);
  if (typeof clearTimer === 'function') {
    clearTimer();
  }
  const timer = setInterval(() => {
    callback();
  }, seconds * 1000);
  scheduleMap.set(tag, () => {
    clearInterval(timer);
  });
};
export const clearScheduleJob = () => {
  scheduleMap.forEach((fun) => {
    fun();
  });
};
